import Vue from 'vue';
import VueGtm from 'vue-gtm';
import { TRACKING_CONFIG } from '../../../utils/configure-environment';

const { trackingId } = TRACKING_CONFIG;

Vue.use(VueGtm, {
  id: trackingId,
  enabled: !!trackingId,
  loadScript: false,
  debug: process.env.NODE_ENV !== 'production'
});
